import SearchResultItem from 'components/search/SearchResultItem';
import { AlgoliaHit } from 'types/Search/Algolia';
import * as styles from './styles/styles.module.scss';
import { FormattedMessage } from '@alltrails/shared/react-intl';

type Props = {
  currentSelection: number;
  displayMetric: boolean;
  handleResultHover: (index: number) => void;
  handleItemClick: (url: string, item: AlgoliaHit, position: number) => void;
  items: AlgoliaHit[];
  latLngForDisplayDistance?: [number, number];
  term: string;
};

function SearchResultList({ currentSelection, displayMetric, handleResultHover, handleItemClick, items, latLngForDisplayDistance, term }: Props) {
  const handleHover = (index: number) => handleResultHover(index);

  return (
    <div key="search-result-list" id="hits">
      {items.length === 0 ? (
        <div className={styles.noResults}>
          <FormattedMessage defaultMessage="No results" />
        </div>
      ) : (
        items.map((result, index) => (
          <SearchResultItem
            data={result}
            index={index}
            isSelected={currentSelection === index}
            key={`search-result-item-${index}`}
            term={term}
            hoverHandle={handleHover}
            handleItemClick={handleItemClick}
            displayMetric={displayMetric}
            latLngForDisplayDistance={latLngForDisplayDistance}
          />
        ))
      )}
    </div>
  );
}

export default SearchResultList;
